import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Test from "./components/Test";

// Import all pages
import Dashboard from "./components/Dashboard";
import Graphs from "./components/Graphs";
import Activities from "./components/Activities";
import Sensors from "./components/Sensors";
import Profile from "./components/Profile";
import Insights from "./components/Insights";
import FAQ from "./components/FAQ";
import Settings from "./components/Settings";
import Landing from "./components/Landing";
import ProtectedRoute from "./components/ProtectedRoute";
import RegisterPage from "./components/RegisterPage";
import AIIntroScreen from "./components/AIIntroScreen";


function App() {
  return (
    <Router>
      <Routes>

        {/* Public */}
        <Route path="/" element={<Landing />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Protected — every page below requires a complete profile.
            ProtectedRoute itself handles the AI-intro one-time redirect
            and mounts the FloatingChatWidget for every child route. */}
        <Route element={<ProtectedRoute />}>
          <Route path="/ai-intro" element={<AIIntroScreen />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/graphs" element={<Graphs />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/sensors" element={<Sensors />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/user" element={<Test />} />
        </Route>

      </Routes>
    </Router>
  );
}


export default App;